import axios from "axios";

import { MCP_CSRF_HEADER_NAME, MCP_CSRF_COOKIE_NAME } from "./token";

axios.defaults.xsrfCookieName = MCP_CSRF_COOKIE_NAME;
axios.defaults.xsrfHeaderName = MCP_CSRF_HEADER_NAME;
